import { useCallback } from 'react';
import { bridge } from '../../../utils';

export const useLogClickBottomTab = () => {
  return useCallback(
    (params: { label: string; currentScreen: string }) => {
      bridge.logAnalyticsEvent({
        name: 'CLICK_BOTTOM_TAB',
        analytics: {
          SCREEN: params.currentScreen,
          LABEL: params.label,
        },
      });
    },
    [],
  );
};
